<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    quickSearchTag: (quickSearchTag$ | async),
    isLoggedIn: (authenticationService.isLoggedIn$() | async),
    advancedSearchEnabled: (advancedSearchEnabled$ | async),
    searchSuggestions: (searchSuggestions$ | async) || [],
    searchRecommendation: (searchRecommendation$ | async)
  }"
>
</ng-container>

<ng-template
  #template
  let-quickSearchTag="quickSearchTag"
  let-isLoggedIn="isLoggedIn"
  let-advancedSearchEnabled="advancedSearchEnabled"
  let-searchSuggestions="searchSuggestions"
  let-searchRecommendation="searchRecommendation"
>
  @if (isLoggedIn?.isAuthenticated) {
    @if (advancedSearchEnabled) {
      <div flexLayout="row" class="adv-search">
        @if (searchRecommendation) {
          <div flexLayout="column" class="search-recommendation" flexLayoutAlign="center center">
            <span>
              Did you mean
              <a class="search-link" (click)="searchRecommended(searchRecommendation)">
                {{ searchRecommendation }} </a
              >?</span
            >
          </div>
        }
        <mat-form-field>
          <input
            #searchInput
            matInput
            class="search-input"
            [formControl]="searchCtrl"
            [placeholder]="
              quickSearchTag
                ? uiDisplayTagService.displayTags[quickSearchTag]
                : quickSearchTag || 'Search'
            "
            focused="focused"
            [matAutocomplete]="auto"
          />

          <button
            matSuffix
            mat-icon-button
            type="button"
            class="suffix"
            [style.visibility]="searchCtrl.value ? 'visible' : 'hidden'"
            (click)="isSearching() ? clear() : searchNow()"
          >
            <mat-icon>close</mat-icon>
          </button>

          <mat-autocomplete #auto="matAutocomplete">
            @for (suggestion of searchSuggestions; track suggestion + '') {
              <mat-option [value]="suggestion">
                {{ suggestion }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    } @else {
      <div flex class="search-container" flexLayout="row" flexLayoutAlign="space-between center">
        <input
          title="Search Currently Displayed Results &#10;  &#x23ce;  Press Enter to Search &#10; &#x232b; Press Delete to Clear"
          matInput
          class="search-input"
          [placeholder]="
            quickSearchTag
              ? uiDisplayTagService.displayTags[quickSearchTag]
              : quickSearchTag || 'Search'
          "
          (keyup)="checkIfEmpty($event)"
          (keyup.enter)="searchNow()"
          [(ngModel)]="input"
          focused="focused"
        />
        <div matSuffix class="suffix">
          <button
            type="button"
            [disableRipple]="true"
            mat-icon-button
            (click)="isSearching() ? clear() : searchNow()"
          >
            <mat-icon color="accent" aria-hidden="false" class="icon" inline="true">
              {{ isSearching() ? "close" : "search" }}
            </mat-icon>
          </button>
        </div>
      </div>
    }
  }
</ng-template>
